export const datasetDataTypesMap: {
  [key: string]: string;
} = {
  claims: 'claims',
  'ehr curated': 'EHR curated',
  'ehr structured': 'EHR structured',
  'mortality registry': 'mortality registry',
  structured: 'EHR structured',
  curated: 'EHR curated',
};

export const dataTypeFormatter = (dataTypes: string[]): string => {
  const formattedDataTypes = dataTypes
    ?.map((dataType) => dataType.toLowerCase())
    .sort()
    .map((dataType) => datasetDataTypesMap[dataType] || dataType || '')
    .join(', ');
  return formattedDataTypes
    ? formattedDataTypes.charAt(0).toUpperCase() + formattedDataTypes.slice(1)
    : '';
};
